import { useSelector } from 'react-redux'

export const useDance = () =>
    useSelector(
        (state) => state.dancesReducer.dance,
        () => {}
    )
export const useDances = () =>
    useSelector(
        (state) => state.dancesReducer.dances,
        () => {}
    )
export const useDanceOnAddProcess = () =>
    useSelector(
        (state) => state.dancesReducer.danceOnAddProcess,
        () => {}
    )
export const useDanceStylesOptions = () =>
    useSelector(
        (state) => state.dancesReducer.danceStylesOptions,
        () => {}
    )

export const useSaveFromReAkumSearch = () =>
    useSelector(
        (state) => state.dancesReducer.saveFromReAkumSearch,
        () => {}
    )
